import { useTitle } from '../../hooks/useTitle'
import * as S from './styles'
import { IMAGE_URL } from '../../constants'
import { useState, useEffect } from 'react'
import { verifyAdvancedPlanImage } from '../../util/verifyAdvancedPlan'

const PageNotFound = () => {
  const [backgroundImage, setBackgroundImage] = useState('/assets/images/ilustracao-login.svg')
  const customerInfo = JSON.parse(localStorage.getItem('customerInfo'))

  const getPageImage = () => {
    const image = verifyAdvancedPlanImage(customerInfo)
    setBackgroundImage(image ? image : '/assets/images/ilustracao-login.svg')
  }

  useEffect(() => {
    if (customerInfo) {
      getPageImage()
    }
  }, [])

  useTitle('Zaub')
  return (
    <S.PageNotFound>
      <S.PageNotFoundContainer>
        <S.PageNotFoundWrapper>
          <S.PageNotFoundImageWrapper>
            <S.PageNotFoundImage src={backgroundImage} alt='Ilustração da tela de página não encontrada.'></S.PageNotFoundImage>
          </S.PageNotFoundImageWrapper>
          <S.PageNotFoundImage backgroundImage={backgroundImage}></S.PageNotFoundImage>
          <S.PageNotFoundInner>
            <S.PageNotFoundLogoWrapper>
              <S.PageNotFoundLogo src={!!customerInfo && customerInfo?.logo ? `${IMAGE_URL}${customerInfo.logo}` : '/assets/images/logo-zaub.png'} />
            </S.PageNotFoundLogoWrapper>
            <S.PageNotFoundTitle>Página não encontrada!</S.PageNotFoundTitle>
          </S.PageNotFoundInner>
        </S.PageNotFoundWrapper>
      </S.PageNotFoundContainer>
    </S.PageNotFound>
  )
}

export default PageNotFound
